import { api, qs } from '../client'
import type { Page, Post, User, UserList } from '../types'

export interface ListInput {
  name: string
  description?: string | null
  is_private?: boolean
}

export const listsApi = {
  /** 我的列表。给了 member 时每个列表带 `viewer.has_member` */
  mine: (member?: string) =>
    api.get<{ items: UserList[]; next_cursor: null }>(`/lists${qs({ member })}`),
  get: (id: string) => api.get<{ list: UserList }>(`/lists/${id}`),
  create: (input: ListInput) => api.post<{ list: UserList }>('/lists', input),
  update: (id: string, patch: Partial<ListInput>) =>
    api.patch<{ list: UserList }>(`/lists/${id}`, patch),
  remove: (id: string) => api.delete<{ ok: true }>(`/lists/${id}`),
  timeline: (id: string, cursor?: string, limit = 20) =>
    api.get<Page<Post>>(`/lists/${id}/timeline${qs({ cursor, limit })}`),
  members: (id: string, cursor?: string, limit = 20) =>
    api.get<Page<User>>(`/lists/${id}/members${qs({ cursor, limit })}`),
  addMember: (id: string, username: string) =>
    api.post<{ list: UserList }>(`/lists/${id}/members/${username}`),
  removeMember: (id: string, username: string) =>
    api.delete<{ list: UserList }>(`/lists/${id}/members/${username}`),
}
